import {
  Button,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import {
  CreateRoomsModal,
  SaveInstallationModal,
  SaveInstallationsModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionLayout } from 'modules/components/layer31';
import { InstallationsSummaryMetricsSection } from 'modules/components/layer35';

import React, { useState } from 'react';

import _ from 'lodash';

import { useReactiveVar } from '@apollo/client';
import {
  filterInstallationsVar,
  resetInstallationFilter
} from 'modules/common/layer00/reactiveVariables';
import { useParams } from 'react-router-dom';



export type ProjectInstallationsHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationsHeaderSectionProps) => {
  const params = useParams();

  return (

    <ActivityHeaderSectionLayout.FC
      title='Selections'
      subtitle=''
      actionButtons={(
        <ActionButtonsGroup
          projectId={params.projectId ?? ''}
        />
      )}
    >
      <InstallationsSummaryMetricsSection.FC />
    </ActivityHeaderSectionLayout.FC>
  );
};



type ActionButtonsGroup = {
  projectId: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isCreateRoomsVisible,
    setIsCreateRoomsVisible
  ] = useState(false);
  const [
    isBulkUpdateVisible,
    setisBulkUpdateVisible
  ] = useState(false);
  const installationFilter = useReactiveVar(filterInstallationsVar);
  return (
    <>
      {isVisible && (
        <SaveInstallationModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      {isBulkUpdateVisible && (
        <SaveInstallationsModal.FC
          isVisible={isBulkUpdateVisible}
          handleClose={() => setisBulkUpdateVisible(() => false)}
          id={props.projectId}
        />
      )}
      {isCreateRoomsVisible && (
        <CreateRoomsModal.FC
          isVisible={isCreateRoomsVisible}
          handleClose={() => setIsCreateRoomsVisible(() => false)}
          id={props.projectId}
        />
      )}
      { !_.valuesIn(installationFilter).every((r) => r === true || r === '' || _.isNull(r)) && (

        <Button
          variant='contained'
          onClick={() => resetInstallationFilter()}
        >
          Reset Filter
        </Button>
      )}
      <Button
        variant='contained'
        color='warning'
        onClick={() => setisBulkUpdateVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SPARKLE'
            stroke={theme.palette.success.contrastText}
          />
        )}
      >
        Bulk Update
      </Button>
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsCreateRoomsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SPARKLE'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create New Room
      </Button>
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SPARKLE'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create New Selection
      </Button>

    </>
  );
};

